import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Input,
  Text,
  Td,
} from "@chakra-ui/react";
import { format } from "date-fns";

export function ModalCubagem({ fechar, salvar, cubagem, isOpen, onChange }) {
  console.log(cubagem);
  return (
    <Modal onClose={fechar} size={"6xl"} isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text as="h1" textAlign="center">
            Alterar Quantidade por Caixa
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <TableContainer scroll={{ x: "100%", y: "100%" }}>
            <Table variant="striped" colorScheme={"gray"}>
              <Thead>
                <Tr>
                  <Th color="blue.400">Descrição</Th>
                  <Th textAlign="center" color="blue.400">
                    ID Caixa
                  </Th>
                  <Th color="blue.400">Dimensões</Th>
                  <Th color="blue.400">Qtd por caixa</Th>
                  <Th color="blue.400">Data Ult. Alteração</Th>
                  <Th color="blue.400">Nome usúario</Th>
                </Tr>
              </Thead>
              <Tbody>
                {cubagem.map((item, index) => (
                  <Tr>
                    <Td>{item.descricao}</Td>
                    <Td textAlign="center">{item.id_caixa}</Td>
                    <Td>{item.caixa}</Td>
                    <Td>
                      <Input
                        id={"quantidade-caixa-" + (index + 1)}
                        data={JSON.stringify(item)}
                        type="text"
                        onChange={onChange}
                        borderColor="gray.300"
                      />
                    </Td>
                    <Td>{item.data_alteracao ? format(new Date(item.data_alteracao), "dd/MM/yyyy HH:mm:ss") : ""}</Td>
                    <Td>{item.nome_usuario}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={salvar}>
            Salvar Alterações
          </Button>
          <Button onClick={fechar}>Fechar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
